<template>
  <div class="mlr birthday-wrap mb-24">
    <div class="mt-24 mb-24 clearfix">
      <h3
        class="text-bold-c111 font-s20 fl"
      >
        {{ TLang('配件选择', 'orderConfirm') }}
      </h3>
      <div class="notice fl ml-12">
        <img
          :src="require('@assets/images/order/notice.png')"
          alt=""
        >
        <span>{{TLang('freightPay', 'address')}}</span>
      </div>
    </div>
    <div
      v-for="(accessoryGroup, accessoryGroupIndex) in accessoryGroupList"
      :id="accessoryGroup.id"
      :key="accessoryGroupIndex"
    >
      <h2 class="text-c111 font-s16 mb-16">
        {{ accessoryGroup.name }}
      </h2>
      <div v-if="merchantId === NOXIN_MERCHANT_ID">
        <NuoXin
          :accessoryItems="accessoryGroup.accessoryItems"
          @setAccessory="setNuoxin"
        />
      </div>
      <div v-else>
        <el-tooltip
          v-for="(accessoryItem, accessoryIndex) in accessoryGroup.accessoryItems"
          :id="accessoryIndex"
          :key="accessoryItem.id"
          effect="light"
          :content="accessoryItem.tip"
          placement="top-start"
        >
          <el-button
            :class="accessoryItem.checked ? 'tag-checked' : ''"
            @click="handlerChecked(accessoryGroupIndex, accessoryIndex)"
          >
            {{ accessoryItem.name }}{{ accessoryItem.value }}
          </el-button>
        </el-tooltip>
        <div v-if="accessoryGroup.input">
          <el-input
            v-model="input"
            :placeholder="placeholder"
            @change="setAccessory"
          ></el-input>
        </div>
      </div>
      <div
        v-if="accessoryGroupIndex !== accessoryGroups.length - 1"
        class="line-dashed mt-12 mb-24"
      ></div>
    </div>
  </div>
</template>

<script>
// const NOXIN_MERCHANT_ID = 222; // 生产
// const NOXIN_MERCHANT_ID = 891; // 测试
// const NOXIN_MERCHANT_ID = 5002; // 测试test01
// const NOXIN_CHOCOLATE_ID = 219;
import NuoXin from './nuoxin';
import API_ENV  from '@utils/API_ENV';

export default {
  name: 'BirthdayParts',
  components: {
    NuoXin,
  },
  props: {
    accessoryGroups: Array,
    deliveryWay: Object,
    merchantId: Number,
  },
  data() {
    return {
      tagValue: '',
      input: '',
      placeholder: '',
      userRemark: [],
      accessoryGroupList: [],
      gIndex: 0,
      aIndex: 0,
      NOXIN_MERCHANT_ID: 5002,
    };
  },
  created() {
    this.accessoryGroupList = this.accessoryGroups;
    if (
      API_ENV === 'production' ||
      API_ENV === 'test' ||
      API_ENV === 'uat' ||
      API_ENV === 'dev' ||
      API_ENV === 'stage'
    ) {
      // 生产环境
      this.NOXIN_MERCHANT_ID = 222;
    } else if (/test\d{2}$/g.test(API_ENV)) {
      // k8s环境
      this.NOXIN_MERCHANT_ID = 5002;
    } else {
      this.NOXIN_MERCHANT_ID = 891;
    }
  },
  methods: {
    handlerChecked(gIndex, aIndex){
      const { accessoryGroupList } = this;
      this.accessoryGroupList = accessoryGroupList.map((gItem, index) => {
        gItem.input = false;
        if (index === gIndex) {
          gItem.accessoryItems.map((aItem, i) => {
            if (i === aIndex) {
              aItem.checked = !aItem.checked;
              if(!!aItem.placeholder && aItem.checked) gItem.input = true;
              if(gItem.input) {
                this.input = aItem.value;
                this.placeholder = aItem.placeholder;
                this.aIndex = aIndex;
                this.gIndex = gIndex;
              }
              if (aItem.checked) {
                this.userRemark.push({
                  id: aItem.id,
                  name: aItem.value || aItem.name,
                });
              } else {
                let i = this.userRemark.findIndex((item) => item.id === aItem.id);
                this.userRemark.splice(i,1);
              }
            }
            return aItem;
          });
        }
        return gItem;
      });

      this.$emit('onResetDeliveryWay', {
        ...this.$props.deliveryWay,
        userRemark: this.userRemark.map(item => item.name).join(','),
      });
    },
    /**
     * 诺心
     * 只传输入文案,不传标签
     */
    setNuoxin(userRemark) {
      this.$emit('onResetDeliveryWay', {
        ...this.$props.deliveryway,
        userRemark: userRemark,
      });
    },
    setAccessory() {
      const { accessoryGroupList } = this;
      const { gIndex, aIndex } = this;
      this.accessoryGroupList = accessoryGroupList.map((gItem, index) => {
        if (index === gIndex) {
          gItem.accessoryItems.map((aItem, i) => {
            if (i === aIndex) {
              aItem.value = this.input;
              this.input = aItem.value;
              this.userRemark[this.userRemark.length - 1].name = aItem.name + aItem.value;

              this.gIndex = null;
              this.aIndex = null;
              this.$emit('onResetDeliveryWay', {
                ...this.$props.deliveryway,
                userRemark: this.userRemark.map(item => item.name).join(','),
              });
            }
            return aItem;
          });
        }
        return gItem;
      });
    },
  },
};
</script>

<style lang="less">
.notice {
  padding: 8px;
  background:#FDECEC;
  border-radius:2px;
  font-size:12px;

  font-weight:400;
  color:#F44545;
  position: relative;
  margin: 0;
  &::before {
    content: '';
    border: solid 4px;
    border-top-color: transparent;
    border-left-color: transparent;
    border-right-color: #FDECEC;
    border-bottom-color: transparent;
    position: absolute;
    top: 14px;
    left: -8px;
  }

  img {
    width: 12px;
    height: 13px;
    vertical-align: top;
  }
}

.tag {
  display: inline-block;
  padding: 8px 12px;
  // margin: 0 12px 12px 0;
  margin-bottom: 12px;
  border-radius:2px;
  font-size:14px;

  background-color:#FAFAFA;
  color: #333333;

  &-checked  {
    color: #3D96E2!important;
    background:#ECF5FD!important;
  }
}

.line-dashed {
  width: 100%;
  border:1px dashed rgba(229,229,229,1);
}

.text-area {
  border: solid 1px#E5E5E5;
}

.el-tooltip__popper {
  padding: 8px 12px;
  margin: 0 12px 12px 0;
  border-radius:2px;
  font-size:14px;

}

.el-tooltip__popper.is-light {
  border: transparent!important;
  color: #3D96E2;
  background:#ECF5FD;

  .popper__arrow {
    border: transparent;
  }
}

.el-button {
  border: none;
  max-width: 100%;
  white-space: normal;
  word-break: break-word;
  text-align: left;
  .tag;

  span {
    border-radius:2px;
    font-size:14px;
  
    transform: scale(1);
  }
}

.el-button:focus, .el-button:hover {
  background-color:#FAFAFA;
  color: #333333;
  border-color: transparent;
}

.db {
   display: block;
}

.dn {
  display: none;
}

.birthday-wrap /deep/ .el-input__inner {
  width:860px;
  height:36px;
  color: #333;
  border-radius: 0;
  background:rgba(255,255,255,1);
  border:1px solid rgba(229,229,229,1);

  ::placeholder {
    color: #f90;
  }
}
</style>